<script lang="ts">
	import GradientBorder from '$lib/util/GradientBorder.svelte';

	export let numberOfMarkets: number;
	export let showFavouritesOnly: boolean;
	export let numberOfFavouriteMarkets: number;
</script>

{#if showFavouritesOnly}
	<div class="py-3 flex justify-start gap-3 mx-2 h-fit">
		<GradientBorder
			gradient="bg-fx-gradient-14"
			paddingClass="p-px"
			borderRadius="rounded-2xl squircle-2xl"
			outerClassList="w-fit"
			innerClassList="flex justify-center bg-fx-black px-2 py-1 gap-1 items-center"
		>
			<img src={'markets/favourite.png'} loading="lazy" alt="star" class="w-3" />
			<div class="text-xs font-medium">Favourites ({numberOfFavouriteMarkets})</div>
		</GradientBorder>

		<div
			class="text-xs font-medium px-2 py-1 border border-fx-grey-500 text-fx-grey-300 squircle-2xl rounded-2xl cursor-pointer"
			on:click={() => (showFavouritesOnly = false)}
			on:keydown={() => (showFavouritesOnly = false)}
			role="presentation"
		>
			All ({numberOfMarkets})
		</div>
	</div>
{:else}
	<div class="py-3 flex justify-start gap-3 mx-2 h-fit">
		<div
			on:click={() => (showFavouritesOnly = true)}
			on:keydown={() => (showFavouritesOnly = true)}
			role="presentation"
			class="text-xs font-medium px-2 py-1 border border-fx-grey-500 text-fx-grey-300 squircle-2xl rounded-2xl cursor-pointer flex gap-1 items-center"
		>
			<img src={'markets/favourite.png'} loading="lazy" alt="star" class="w-3 h-3" />
			<div class="text-xs font-medium">Favourites ({numberOfFavouriteMarkets})</div>
		</div>
		<GradientBorder
			gradient="bg-fx-gradient-14"
			paddingClass="p-px"
			borderRadius="rounded-2xl squircle-2xl"
			outerClassList="w-fit"
			innerClassList="flex justify-center items-center bg-fx-black px-2 py-1 gap-1 text-xs font-medium"
		>
			All ({numberOfMarkets})
		</GradientBorder>
	</div>
{/if}
